module.exports = __webpack_public_path__ + "img/Mascot_assuraf.8c85c1ac.png";